export default __webpack_public_path__ + "static/media/add.63297869.svg";